import {bufferTime, catchError, distinct, filter, first, groupBy, map, mapTo, mergeMap, tap} from "rxjs/operators";
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  API_GET_RFI,
  API_GET_RFI_DONE,
  API_GET_RFIS,
  API_GET_RFIS_DONE,
  getRfiDone,
  getRfis,
  getRfisDone
} from "../actions/rfis";
import * as R from 'ramda';
import {getProjectRfis$, getProjectRfisMulti$} from "../services/projects";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {injectSubview, setSubview, setSubviewCache} from "../actions/view";

const SVCLF = setSubviewCache({ loading: false });

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_RFI),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: true })),
  catchErrorsandResume(20050)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_RFI_DONE, API_GET_RFIS_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: false })),
  catchErrorsandResume(20051)
);

const getSingleEpic = action$ => action$.pipe(
  ofType(API_GET_RFI),
  mergeMap(action => getProjectRfis$({ id: action.payload.id, projectId: action.payload.projectId }).pipe(
    map(({ response }) => getRfiDone(response)),
    catchError(error => of(SVCLF, networkError({ ...error, number: '10095-' + error.status })))
  )),
  catchErrorsandResume(20054)
);

const getSingleMulti = action$ => action$.pipe(
  ofType(API_GET_RFI),
  groupBy(action => action.payload.projectId),
  mergeMap(group$ => group$.pipe(
    distinct(action => action.payload.id, requestDedupInterval$),
    bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
    filter(actions => actions.length > 0),
    mergeMap(actions => getProjectRfisMulti$({ projectId: actions[0].payload.projectId, ids: actions.map(action => action.payload.id) }).pipe(
      filter(({ response }) => response && response['results']),
      map(({ response }) => setSubview(response.results)),
      catchError(error => of(SVCLF, networkError({ ...error, number: '10096-' + error.status }))),
    )),
    catchError(error => of(SVCLF, networkError({ ...error, number: '10097-' + error.status }))),
  )),
  catchErrorsandResume(20055)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_RFI_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(rfis => rfis[0].callback && rfis[0].callback(rfis[0].response.resource.id)),
  map(results => results.map(rfi => rfi.response)),
  map(results => setSubview(results)),
  catchErrorsandResume(20057)
);

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_RFIS),
  mergeMap(action => getProjectRfis$({ id: action.payload.id, projectId: action.payload.projectId, offset: action.payload.offset }).pipe(
    map(({ response }) => getRfisDone(response)),
    catchError(error => of(SVCLF, networkError({ ...error, number: '10098-' + error.status })))
  )),
  catchErrorsandResume(20053)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_RFIS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => injectSubview(results)),
  catchErrorsandResume(20056)
);

const getMoreEpic = action$ => action$.pipe(
  ofType(API_GET_RFIS_DONE),
  filter(action => action.payload && action.payload.results && action.payload.results.length === action.payload.limit),
  map(action => getRfis(action.payload.results.slice(-1)[0].resource.projectid, action.payload.results.slice(-1)[0].resource.id)),
  catchErrorsandResume(20052)
);

export const rfisEpic = combineEpics(
  beginLoading,
  endLoading,
  // getSingleEpic,
  getSingleMulti,
  processSingleEpic,
  getMultipleEpic,
  processMultipleEpic,
  getMoreEpic
);



// WEBPACK FOOTER //
// ./src/network/rfis.js